import React from 'react';
import { Button, Container } from 'react-bootstrap';
import FaChevronLeft from '../icons/FaChevronLeft';
import FaChevronRight from '../icons/FaChevronRight';

import '../styles/PageNav.css';
import { array, func, number } from 'prop-types';

export default function PageNav({ curPage, totalPages, generatedPagesData, paginateUser = () => {} }) {
    return (<>
        {totalPages > 0 && (
            <Container
                className={'page--list-nav'}>
                <Button
                    aria-label={'Previous'}
                    onClick={() => paginateUser(curPage - 1)}
                    className={'page--list-btn'}
                    disabled={curPage <= 0}><FaChevronLeft
                        style={{ verticalAlign: 'middle' }}
                        size={'15px'} /></Button>
                {generatedPagesData.map((page) => (<Button
                    aria-label={'Go to page ' + page.displayPage}
                    key={'page-' + page.page}
                    onClick={() => paginateUser(page.page)}
                    className={'page--list-btn-number'}
                    disabled={curPage === page.page}>{page.displayPage}</Button>))}
                <Button
                    aria-label={'Next'}
                    onClick={() => paginateUser(curPage + 1)}
                    className={'page--list-btn'}
                    disabled={curPage >= totalPages}><FaChevronRight
                        style={{ verticalAlign: 'middle' }}
                        size={'15px'} /></Button>
            </Container>
        )}
    </>);
}

PageNav.propTypes = {
    curPage: number,
    totalPages: number,
    generatedPagesData: array,
    paginateUser: func,
};